/* Generated from src/chart/injectStyles.scss — do not edit directly. */
@charset "UTF-8";
.an26-root {font-family: var(--an26-font-body);
  font-weight: 300;
  color: var(--an26-text-primary);
  box-sizing: border-box;
  background: var(--an26-bg);
  line-height: 1.45;
}.an26-root *, .nten-root *, .an26-root *::before, .nten-root *::before, .an26-root *::after, .nten-root *::after{
  box-sizing: border-box;
}.an26-root--bar, .nten-root--bar, .an26-root--line, .nten-root--line, .an26-root--hbar, .nten-root--hbar, .an26-root--split-hbar, .nten-root--split-hbar, .an26-root--stats, .nten-root--stats, .an26-root--avg, .nten-root--avg{
  padding: 0 var(--an26-space-md);
}.an26-root__head, .nten-root__head{
  margin-bottom: var(--an26-space-lg);
}.an26-root__subtitle--stats, .nten-root__subtitle--stats, .an26-root__subtitle--avg, .nten-root__subtitle--avg{
  font-weight: 500;
  color: var(--an26-text-primary);
}.an26-root--avg .an26-root__title, .nten-root--avg .nten-root__title{
  font-weight: 500;
}.an26-root__title, .nten-root__title{
  font-family: var(--an26-font-heading);
  font-weight: 300;
  font-size: var(--an26-fs-title-sm);
  margin: 0 0 var(--an26-space-sm);
  color: var(--an26-text-bold);
  letter-spacing: 0.01em;
}.an26-root__subtitle, .nten-root__subtitle{
  font-family: var(--an26-font-body);
  font-weight: 500;
  font-size: var(--an26-fs-subtitle);
  color: var(--an26-text-bold);
  margin: 0;
}.an26-root__chart-wrap, .nten-root__chart-wrap{
  margin: var(--an26-space-md) 0 var(--an26-space-lg);
}.an26-root__chart, .nten-root__chart{
  min-height: 280px;
  width: 100%;
}.an26-line-chart__scroll, .nten-line-chart__scroll{
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
}@media (max-width: 560px) {.an26-line-chart__scroll .an26-line-chart__plot, .nten-line-chart__scroll .nten-line-chart__plot{
    width: auto;
    min-width: 420px;
  }}@media (max-width: 640px) {.an26-root--line, .nten-root--line{
    padding: 0 var(--an26-space-sm);
  }.an26-root--line .an26-root__head, .nten-root--line .nten-root__head{
    margin-bottom: var(--an26-space-md);
  }.an26-root--line .an26-root__chart-wrap, .nten-root--line .nten-root__chart-wrap{
    margin: var(--an26-space-sm) 0 var(--an26-space-md);
  }.an26-root--line .an26-table-wrap, .nten-root--line .nten-table-wrap{
    margin-top: var(--an26-space-md);
  }}.an26-table-wrap, .nten-table-wrap{
  width: 100%;
  overflow-x: auto;
  margin-top: var(--an26-space-lg);
}.an26-table, .nten-table{
  width: 100%;
  border-collapse: collapse;
  font-family: var(--an26-font-body);
  font-size: var(--an26-fs-body);
}.an26-table th, .nten-table th, .an26-table td, .nten-table td{
  border: 1px solid var(--an26-border);
  padding: var(--an26-space-sm) var(--an26-space-md);
  vertical-align: middle;
}.an26-table th:first-child, .nten-table th:first-child, .an26-table td:first-child, .nten-table td:first-child{
  font-weight: 500;
}.an26-table th:not(:first-child), .nten-table th:not(:first-child), .an26-table td:not(:first-child), .nten-table td:not(:first-child){
  font-weight: 200;
}.an26-table thead th, .nten-table thead th{
  font-size: var(--an26-fs-mono);
  text-align: center;
  font-weight: 200;
  font-synthesis: none;
}.an26-table thead th.an26-table__corner, .nten-table thead th.nten-table__corner{
  text-align: left;
  font-family: var(--an26-font-body);
  font-size: var(--an26-fs-table-head);
  font-weight: 500;
}.an26-table--bar thead th:not(:first-child), .nten-table--bar thead th:not(:first-child){
  font-family: var(--an26-font-mono);
  font-size: 8pt;
  font-weight: 300;
}.an26-table--bar thead th.an26-table__corner, .nten-table--bar thead th.nten-table__corner, .an26-table--bar tbody td.an26-table__label, .nten-table--bar tbody td.nten-table__label{
  font-family: var(--an26-font-body);
  font-weight: 500;
}.an26-table--bar tbody td:not(:first-child), .nten-table--bar tbody td:not(:first-child){
  font-family: var(--an26-font-body);
  font-weight: 300;
}.an26-table--line thead th:not(:first-child), .nten-table--line thead th:not(:first-child){
  font-family: var(--an26-font-mono);
  font-size: 8pt;
  font-weight: 200;
}.an26-table tbody td, .nten-table tbody td{
  text-align: center;
}.an26-table tbody td.an26-table__label, .nten-table tbody td.nten-table__label{
  text-align: left;
}.an26-table--bar th, .nten-table--bar th, .an26-table--bar td, .nten-table--bar td, .an26-table--line th, .nten-table--line th, .an26-table--line td, .nten-table--line td{
  background: var(--an26-bg);
}.an26-table--bar thead th, .nten-table--bar thead th, .an26-table--line thead th, .nten-table--line thead th{
  background: var(--an26-bg);
  border-top: none;
}.an26-table--bar th:first-child, .nten-table--bar th:first-child, .an26-table--bar td:first-child, .nten-table--bar td:first-child, .an26-table--line th:first-child, .nten-table--line th:first-child, .an26-table--line td:first-child, .nten-table--line td:first-child{
  border-left: none;
}.an26-table--bar th:last-child, .nten-table--bar th:last-child, .an26-table--bar td:last-child, .nten-table--bar td:last-child, .an26-table--line th:last-child, .nten-table--line th:last-child, .an26-table--line td:last-child, .nten-table--line td:last-child{
  border-right: none;
}.an26-table--bar tbody tr:last-child td, .nten-table--bar tbody tr:last-child td, .an26-table--line tbody tr:last-child td, .nten-table--line tbody tr:last-child td{
  border-bottom: none;
}.an26-table--split-hbar th, .nten-table--split-hbar th, .an26-table--split-hbar td, .nten-table--split-hbar td{
  background: var(--an26-bg);
}.an26-table--split-hbar thead th, .nten-table--split-hbar thead th{
  background: var(--an26-bg);
  border-top: none;
}.an26-table--split-hbar thead th.an26-table--split-hbar__val, .nten-table--split-hbar thead th.nten-table--split-hbar__val{
  font-family: var(--an26-font-mono);
  font-weight: 300;
  text-align: right;
}.an26-table--split-hbar tbody td.an26-table__label, .nten-table--split-hbar tbody td.nten-table__label{
  font-family: var(--an26-font-body);
  font-weight: 500;
  text-align: left;
}.an26-table--split-hbar tbody td.an26-table--split-hbar__val, .nten-table--split-hbar tbody td.nten-table--split-hbar__val{
  font-family: var(--an26-font-body);
  font-weight: 300;
  text-align: right;
}.an26-table--split-hbar th:first-child, .nten-table--split-hbar th:first-child, .an26-table--split-hbar td:first-child, .nten-table--split-hbar td:first-child{
  border-left: none;
}.an26-table--split-hbar th:last-child, .nten-table--split-hbar th:last-child, .an26-table--split-hbar td:last-child, .nten-table--split-hbar td:last-child{
  border-right: none;
}.an26-table--split-hbar tbody tr:last-child td, .nten-table--split-hbar tbody tr:last-child td{
  border-bottom: none;
}.an26-table__th-sub, .nten-table__th-sub{
  display: block;
  font-size: 8pt;
  font-weight: 200;
  line-height: 1.35;
  margin-top: 2px;
}.an26-table__swatch, .nten-table__swatch{
  display: inline-block;
  width: 18px;
  height: 4px;
  margin-right: 8px;
  vertical-align: middle;
}.an26-table__swatch--line, .nten-table__swatch--line{
  height: 3px;
  border-radius: 0;
}.an26-legend, .nten-legend{
  display: flex;
  flex-wrap: wrap;
  gap: var(--an26-space-md) var(--an26-space-xl);
  margin-top: var(--an26-space-md);
  font-size: var(--an26-fs-body);
  font-weight: 500;
}.an26-legend__item, .nten-legend__item{
  display: inline-flex;
  align-items: center;
  gap: 8px;
}.an26-legend__sw, .nten-legend__sw{
  width: 20px;
  height: 10px;
  border-radius: 0;
}.an26-tooltip-hc, .nten-tooltip-hc{
  padding: 6px 10px;
  font-family: var(--an26-font-body);
  font-size: 12px;
  color: var(--an26-text-primary);
  background: var(--an26-tooltip-bg);
  border: 1px solid var(--an26-tooltip-border);
  border-radius: var(--an26-tooltip-radius);
}.an26-tooltip-hc__date, .nten-tooltip-hc__date{
  font-weight: 300;
  color: var(--an26-text-secondary);
  margin-bottom: 4px;
}.an26-tooltip-hc__line, .nten-tooltip-hc__line{
  font-weight: 300;
}.an26-tooltip-hc__val, .nten-tooltip-hc__val{
  font-weight: 500;
}.an26-split, .nten-split{
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--an26-space-xl);
  align-items: start;
}@media (min-width: 900px) {.an26-split--avg, .nten-split--avg{
    grid-template-columns: minmax(0, 1.35fr) minmax(0, 0.9fr);
  }.an26-split--stats, .nten-split--stats{
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
  }.an26-split--split-hbar, .nten-split--split-hbar{
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }}.an26-split-hbar__table, .nten-split-hbar__table, .an26-split-hbar__chart, .nten-split-hbar__chart{
  min-width: 0;
}.an26-split-hbar__chart .an26-root__chart-wrap, .nten-split-hbar__chart .nten-root__chart-wrap{
  margin-bottom: var(--an26-space-sm);
}.an26-root--split-hbar .an26-root__chart, .nten-root--split-hbar .nten-root__chart{
  min-height: 0;
}.an26-avgret__col, .nten-avgret__col{
  min-width: 0;
}.an26-avgret__toolbar, .nten-avgret__toolbar{
  display: flex;
  justify-content: flex-end;
  margin-bottom: var(--an26-space-sm);
}.an26-toggle, .nten-toggle{
  display: inline-flex;
  border: 1px solid var(--an26-toggle-border);
  overflow: hidden;
  background: var(--an26-bg);
}.an26-toggle__btn, .nten-toggle__btn{
  padding: 8px 18px;
  font-family: var(--an26-font-body);
  font-weight: 500;
  font-size: var(--an26-fs-body);
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--an26-text-bold);
}.an26-toggle__btn + .an26-toggle__btn, .nten-toggle__btn + .nten-toggle__btn{
  border-left: 1px solid var(--an26-toggle-border);
}.an26-toggle__btn.is-active, .nten-toggle__btn.is-active{
  background: var(--an26-toggle-active-bg);
}.an26-avgret__tablewrap, .nten-avgret__tablewrap, .an26-stats__tablewrap, .nten-stats__tablewrap{
  width: 100%;
  overflow-x: auto;
}.an26-avgret__table.an26-table, .nten-avgret__table.nten-table{
  width: 100%;
  border-collapse: collapse;
  background: transparent;
  font-size: var(--an26-fs-body);
}.an26-avgret__table.an26-table th, .nten-avgret__table.nten-table th, .an26-avgret__table.an26-table td, .nten-avgret__table.nten-table td{
  border: none;
  vertical-align: middle;
  padding: var(--an26-space-md);
}.an26-avgret__table.an26-table thead th, .nten-avgret__table.nten-table thead th{
  font-family: var(--an26-font-mono);
  font-size: var(--an26-fs-mono);
  font-weight: 300;
  text-align: center;
  background: transparent;
  color: var(--an26-text-primary);
  border-bottom: 1px solid var(--an26-border-strong);
}.an26-avgret__table.an26-table thead th:not(:last-child), .nten-avgret__table.nten-table thead th:not(:last-child){
  border-right: 1px solid var(--an26-border);
}.an26-avgret__table.an26-table thead th.an26-avgret__th-corner, .nten-avgret__table.nten-table thead th.nten-avgret__th-corner, .an26-avgret__table.an26-table tbody td.an26-avgret__td-ticker, .nten-avgret__table.nten-table tbody td.nten-avgret__td-ticker{
  text-align: left;
}.an26-avgret__table.an26-table .an26-avgret__th-sub, .nten-avgret__table.nten-table .nten-avgret__th-sub{
  display: block;
  font-size: 0.6875rem;
  font-weight: 200;
  line-height: 1.35;
  margin-top: 2px;
}.an26-avgret__table.an26-table tbody td, .nten-avgret__table.nten-table tbody td{
  font-family: var(--an26-font-body);
  font-size: var(--an26-fs-body);
  text-align: center;
  border-bottom: 1px solid var(--an26-border-strong);
}.an26-avgret__table.an26-table tbody td.an26-avgret__td-val, .nten-avgret__table.nten-table tbody td.nten-avgret__td-val{
  font-weight: 500;
}.an26-avgret__table.an26-table tbody td:not(:last-child), .nten-avgret__table.nten-table tbody td:not(:last-child){
  border-right: 1px solid var(--an26-border);
}.an26-avgret__aside, .nten-avgret__aside, .an26-stats__aside, .nten-stats__aside{
  font-size: var(--an26-fs-body);
  line-height: 1.55;
  min-width: 0;
}.an26-avgret__disc, .nten-avgret__disc{
  font-size: var(--an26-fs-body);
  font-weight: 300;
  color: var(--an26-text-primary);
  line-height: 1.55;
  margin: 0;
  text-align: left;
}.an26-avgret__disc b, .nten-avgret__disc b, .an26-avgret__disc strong, .nten-avgret__disc strong{
  font-weight: 500;
}.an26-bar__disc, .nten-bar__disc{
  margin: var(--an26-space-xl) 0 0;
  font-size: var(--an26-fs-table-head);
  font-weight: 300;
  line-height: 1.55;
  color: var(--an26-text-secondary);
  text-align: left;
}.an26-bar__disc b, .nten-bar__disc b, .an26-bar__disc strong, .nten-bar__disc strong{
  font-weight: 500;
  color: var(--an26-text-primary);
}.an26-line__disc, .nten-line__disc{
  margin: var(--an26-space-xl) 0 0;
  font-size: var(--an26-fs-table-head);
  font-weight: 300;
  line-height: 1.55;
  color: var(--an26-text-secondary);
  text-align: left;
}.an26-line__disc b, .nten-line__disc b, .an26-line__disc strong, .nten-line__disc strong{
  font-weight: 500;
  color: var(--an26-text-primary);
}.an26-stats__table.an26-table, .nten-stats__table.nten-table{
  border: none;
  background: transparent;
}.an26-stats__table.an26-table th, .nten-stats__table.nten-table th, .an26-stats__table.an26-table td, .nten-stats__table.nten-table td{
  border: none;
  background: transparent;
}.an26-stats__table.an26-table thead th, .nten-stats__table.nten-table thead th{
  font-size: var(--an26-fs-subtitle);
  color: var(--an26-text-secondary);
  padding: var(--an26-space-sm) var(--an26-space-md);
  border-bottom: 1px solid var(--an26-border-strong);
}.an26-stats__table.an26-table thead th.an26-stats__th-num, .nten-stats__table.nten-table thead th.nten-stats__th-num{
  font-family: var(--an26-font-mono);
  font-weight: 300;
  text-align: right;
}.an26-stats__table.an26-table thead th.an26-stats__th-corner, .nten-stats__table.nten-table thead th.nten-stats__th-corner{
  text-align: left;
}.an26-stats__table.an26-table tbody td.an26-stats__label, .nten-stats__table.nten-table tbody td.nten-stats__label{
  font-family: var(--an26-font-body);
  font-weight: 500;
  text-align: left;
}.an26-stats__table.an26-table tbody td.an26-stats__num, .nten-stats__table.nten-table tbody td.nten-stats__num{
  font-family: var(--an26-font-body);
  font-weight: 300;
  text-align: right;
}.an26-stats__table.an26-table tbody td, .nten-stats__table.nten-table tbody td{
  padding: var(--an26-space-sm) var(--an26-space-md);
  font-size: var(--an26-fs-body);
}.an26-stats__disc, .nten-stats__disc{
  font-size: var(--an26-fs-body);
  font-weight: 300;
  color: var(--an26-text-primary);
  line-height: 1.55;
  margin: 0;
  text-align: left;
}.an26-stats__disc b, .nten-stats__disc b, .an26-stats__disc strong, .nten-stats__disc strong{
  font-weight: 500;
}.an26-holdings, .nten-holdings{
  background: var(--an26-bg);
  padding: var(--an26-space-lg) var(--an26-space-md) var(--an26-space-xl);
}.an26-holdings__actions, .nten-holdings__actions{
  display: flex;
  flex-wrap: wrap;
  gap: var(--an26-space-md);
  margin: var(--an26-space-md) 0 var(--an26-space-lg);
}.an26-holdings__btn, .nten-holdings__btn{
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--an26-font-body);
  font-weight: 500;
  font-size: var(--an26-fs-body);
  color: var(--an26-text-bold);
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: none;
}.an26-holdings__btn:hover, .nten-holdings__btn:hover{
  color: var(--an26-text-secondary);
}.an26-holdings__btn-icon, .nten-holdings__btn-icon{
  color: #b8b8b8;
}.an26-holdings__scroll, .nten-holdings__scroll{
  overflow-x: auto;
  overflow-y: visible;
  border: none;
  -webkit-overflow-scrolling: touch;
}.an26-holdings__more-wrap, .nten-holdings__more-wrap{
  display: flex;
  justify-content: center;
  margin-top: 0;
  padding: 0.5rem 0 0;
  border-top: 1px solid var(--an26-border);
  background: var(--an26-bg-holdings);
}.an26-holdings__more-wrap[hidden], .nten-holdings__more-wrap[hidden]{
  display: none !important;
}.an26-holdings__disc, .nten-holdings__disc{
  margin: var(--an26-space-lg) 0 0;
  font-size: var(--an26-fs-body);
  font-weight: 300;
  color: var(--an26-text-primary);
  line-height: 1.55;
  text-align: left;
}.an26-holdings__disc b, .nten-holdings__disc b, .an26-holdings__disc strong, .nten-holdings__disc strong{
  font-weight: 500;
}.an26-holdings__more, .nten-holdings__more{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2rem;
  padding: 0.25rem 0.75rem;
  font-family: var(--an26-font-body);
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1.2;
  color: var(--an26-text-bold);
  background: transparent;
  border: 0px solid var(--an26-border);
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: var(--an26-space-md);
}.an26-holdings__more:hover, .nten-holdings__more:hover{
  border-color: var(--an26-toggle-border);
  background: var(--an26-bg);
}.an26-holdings__more:focus-visible, .nten-holdings__more:focus-visible{
  outline: 2px solid var(--an26-border-strong);
  outline-offset: 2px;
}.an26-holdings .an26-holdings__table.an26-table, .nten-holdings .nten-holdings__table.nten-table{
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: none;
  background: transparent;
  margin-bottom: 0;
}.an26-holdings .an26-holdings__table thead th, .nten-holdings .nten-holdings__table thead th, .an26-holdings .an26-holdings__table thead th:first-child, .nten-holdings .nten-holdings__table thead th:first-child, .an26-holdings .an26-holdings__table thead th:not(:first-child), .nten-holdings .nten-holdings__table thead th:not(:first-child){
  font-weight: 200;
}.an26-holdings .an26-holdings__table thead th, .nten-holdings .nten-holdings__table thead th{
  position: sticky;
  top: 0;
  z-index: 1;
  font-family: var(--an26-font-mono);
  font-size: var(--an26-fs-body);
  text-align: center;
  background: var(--an26-bg);
  color: var(--an26-text-primary);
  border: none;
  border-bottom: 1px solid var(--an26-border-strong);
  padding: var(--an26-space-sm) var(--an26-space-md);
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
}.an26-holdings .an26-holdings__table thead th:not(:last-child), .nten-holdings .nten-holdings__table thead th:not(:last-child){
  border-right: 1px solid var(--an26-border);
}.an26-holdings .an26-holdings__table thead th:focus-visible, .nten-holdings .nten-holdings__table thead th:focus-visible{
  outline: 2px solid var(--an26-border-strong);
  outline-offset: 2px;
}.an26-holdings .an26-holdings__table tbody td, .nten-holdings .nten-holdings__table tbody td, .an26-holdings .an26-holdings__table tbody td:first-child, .nten-holdings .nten-holdings__table tbody td:first-child, .an26-holdings .an26-holdings__table tbody td:not(:first-child), .nten-holdings .nten-holdings__table tbody td:not(:first-child){
  font-weight: 500;
}.an26-holdings .an26-holdings__table tbody td, .nten-holdings .nten-holdings__table tbody td{
  font-family: var(--an26-font-body);
  font-size: var(--an26-fs-body);
  text-align: center;
  border: none;
  border-bottom: 1px solid var(--an26-border);
  padding: var(--an26-space-sm) var(--an26-space-md);
  vertical-align: middle;
  background: var(--an26-bg-holdings);
}.an26-holdings .an26-holdings__table tbody td:not(:last-child), .nten-holdings .nten-holdings__table tbody td:not(:last-child){
  border-right: 1px solid var(--an26-border);
}.an26-holdings .an26-holdings__table tbody tr:last-child td, .nten-holdings .nten-holdings__table tbody tr:last-child td{
  border-bottom: none;
}.an26-holdings .an26-holdings__table thead th[aria-sort=ascending]::after, .nten-holdings .nten-holdings__table thead th[aria-sort=ascending]::after{
  content: " ↑";
  font-size: 0.75em;
  font-weight: 200;
}.an26-holdings .an26-holdings__table thead th[aria-sort=descending]::after, .nten-holdings .nten-holdings__table thead th[aria-sort=descending]::after{
  content: " ↓";
  font-size: 0.75em;
  font-weight: 200;
}.an26-root--embedded, .nten-root--embedded{
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
}.an26-tabbed, .nten-tabbed, .nten-tabbed{
  font-family: var(--an26-font-body);
  color: var(--an26-text-primary);
  background: var(--an26-bg);
  box-sizing: border-box;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}.an26-tabbed__content, .nten-tabbed__content, .nten-tabbed__content{
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0 var(--an26-space-md);
  width: 100%;
}.an26-tabbed .an26-root__title, .nten-tabbed .nten-root__title, .nten-tabbed .nten-root__title{
  margin-left: 0;
  padding-left: 0;
}.an26-tabbed .an26-root__head, .nten-tabbed .nten-root__head, .nten-tabbed .nten-root__head{
  margin: 0 0 var(--an26-space-sm);
  padding: 0;
}.an26-tabbed__tabs, .nten-tabbed__tabs, .nten-tabbed__tabs{
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0;
  margin: 0 0 var(--an26-space-lg);
  padding: 0;
  max-width: 100%;
  align-self: flex-start;
  border-top: 1px solid var(--an26-border);
  border-bottom: 1px solid var(--an26-border);
}.an26-tabbed__tab, .nten-tabbed__tab, .nten-tabbed__tab{
  flex: 0 0 auto;
  font-family: var(--an26-font-body);
  font-size: var(--an26-fs-body);
  font-weight: 500;
  padding: var(--an26-space-sm) var(--an26-space-md);
  background: #fff;
  color: var(--an26-text-primary);
  border: none;
  border-left: 1px solid var(--an26-border);
  border-radius: 0;
  cursor: pointer;
  text-align: center;
  line-height: 1.3;
}.an26-tabbed__tab:last-child, .nten-tabbed__tab:last-child, .nten-tabbed__tab:last-child{
  border-right: 1px solid var(--an26-border);
}.an26-tabbed__tab.is-active, .nten-tabbed__tab.is-active, .nten-tabbed__tab.is-active{
  background: var(--an26-series-1, #e3dabb);
  border: 1px solid var(--an26-border-strong);
  z-index: 1;
  position: relative;
}.an26-tabbed__tab:focus-visible, .nten-tabbed__tab:focus-visible, .nten-tabbed__tab:focus-visible{
  outline: 2px solid var(--an26-border-strong);
  outline-offset: 2px;
}.an26-tabbed__pane-head, .nten-tabbed__pane-head, .nten-tabbed__pane-head{
  margin-bottom: var(--an26-space-lg);
}.an26-tabbed__pane-title, .nten-tabbed__pane-title, .nten-tabbed__pane-title{
  font-family: var(--an26-font-heading);
  font-weight: 300;
  font-size: var(--an26-fs-title-sm);
  margin: 0 0 var(--an26-space-xs);
  color: var(--an26-text-bold);
}.an26-tabbed__pane-subtitle, .nten-tabbed__pane-subtitle, .nten-tabbed__pane-subtitle{
  font-family: var(--an26-font-body);
  font-weight: 500;
  font-size: var(--an26-fs-subtitle);
  margin: 0;
  color: var(--an26-text-primary);
}.an26-tabbed__panel, .nten-tabbed__panel, .nten-tabbed__panel{
  margin: 0;
  padding: 0;
  min-width: 0;
}.an26-tabbed__mount, .nten-tabbed__mount, .nten-tabbed__mount{
  min-height: 200px;
  margin: 0;
  padding: 0;
}.an26-tabbed .an26-root--embedded .an26-root__chart-wrap, .nten-tabbed .nten-root--embedded .nten-root__chart-wrap, .nten-tabbed .nten-root--embedded .nten-root__chart-wrap{
  margin-left: 0;
  margin-right: 0;
}.an26-tabbed__disclaimer, .nten-tabbed__disclaimer, .an26-tabbed__shell-disclaimer, .nten-tabbed__shell-disclaimer, .nten-tabbed__disclaimer, .nten-tabbed__shell-disclaimer{
  margin: var(--an26-space-xl) 0 0;
  padding: 0;
  border: none;
  font-family: var(--an26-font-body);
  font-size: var(--an26-fs-table-head);
  font-weight: 300;
  line-height: 1.55;
  color: var(--an26-text-secondary);
}.an26-tabbed__disclaimer-p, .nten-tabbed__disclaimer-p, .nten-tabbed__disclaimer-p{
  margin: 0 0 var(--an26-space-md);
}.an26-tabbed__disclaimer-p:last-child, .nten-tabbed__disclaimer-p:last-child, .nten-tabbed__disclaimer-p:last-child{
  margin-bottom: 0;
}.an26-tabbed__disclaimer-p strong, .nten-tabbed__disclaimer-p strong, .nten-tabbed__disclaimer-p strong{
  font-weight: 500;
  color: var(--an26-text-primary);
}.an26-tabbed__disclaimer-benchmark, .nten-tabbed__disclaimer-benchmark, .nten-tabbed__disclaimer-benchmark{
  color: #c45c26;
  font-weight: 500;
}.an26-tabbed__disclaimer-body, .nten-tabbed__disclaimer-body, .nten-tabbed__disclaimer-body{
  font-size: var(--an26-fs-table-head);
  font-weight: 300;
  line-height: 1.55;
  color: var(--an26-text-secondary);
}.an26-tabbed__disclaimer-body b, .nten-tabbed__disclaimer-body b, .an26-tabbed__disclaimer-body strong, .nten-tabbed__disclaimer-body strong, .nten-tabbed__disclaimer-body b, .nten-tabbed__disclaimer-body strong{
  font-weight: 500;
  color: var(--an26-text-primary);
}.an26-tabbed__disclaimer.is-hidden, .nten-tabbed__disclaimer.is-hidden, .an26-tabbed__shell-disclaimer.is-hidden, .nten-tabbed__shell-disclaimer.is-hidden, .nten-tabbed__disclaimer.is-hidden, .nten-tabbed__shell-disclaimer.is-hidden{
  display: none;
}